import { render, staticRenderFns } from "./RenderLabelHtml.vue?vue&type=template&id=0f2aad78&scoped=true"
import script from "./RenderLabelHtml.vue?vue&type=script&lang=ts"
export * from "./RenderLabelHtml.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2aad78",
  null
  
)

export default component.exports